import { calculateExtraStatisticsFields } from './utils'
import _ from 'lodash'

// Statistics by each provider
export default class Divided {
  constructor(statistics, providers) {
    this.statistics = statistics
    this.providers = providers
  }

  calculate() {
    return _.map(this.providers, (provider) => {
      let statistics = _.find(this.statistics, { providerName: provider })

      if (_.isUndefined(statistics)) {
        return calculateExtraStatisticsFields({
          providerName: provider,
          spent: 0,
          clicks: 0,
          impressions: 0,
          goals: 0,
          counterImpressions: 0
        })
      }

      const { spent, impressions, clicks, goals, counterImpressions } = statistics

      const finalSpent = _.isNull(spent) ? 0 : parseFloat(spent)
      const finalGoals = goals ? _.sum(_.flatten(goals)) : 0

      return calculateExtraStatisticsFields({
        providerName: provider,
        spent: finalSpent,
        impressions,
        clicks,
        goals: finalGoals,
        counterImpressions
      })
    })
  }
}
